
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./typescript-vfs.cjs.production.min.js')
} else {
  module.exports = require('./typescript-vfs.cjs.development.js')
}
